(() => {
const parse = (product, brands) => {
 if (!/Precortado/i.test(product.product_type)) return null;
 let text = product.title.replace(/^Kit (?:Frontal PPF|Completo PPF Exterior)\s+/i, '').replace(/^PPF Pre-Corte\s+/i, '');
 const brand = brands.find(b => text.toLowerCase().startsWith(b.toLowerCase() + ' '));
 if (!brand) return null;
 let model = text.slice(brand.length).trim().split(' · ')[0];
 const match = model.match(/\s((?:19|20)\d{2})(?:[-–]((?:19|20)\d{2}))?$/);
 let years = [];
 if (match) {
  const start = Number(match[1]), end = Number(match[2] || match[1]);
  if (end >= start && end - start <= 50) {
   years = Array.from({length:end-start+1}, (_,i) => String(start+i));
   model = model.slice(0,match.index);
  }
 }
 return {brand,model,years,title:product.title,handle:product.handle};
};
const initialize = async root => {
 if (root.dataset.initialized) return;
 root.dataset.initialized = 'true';
 const msg = JSON.parse(root.querySelector('[data-messages]').textContent);
 const brands = JSON.parse(root.dataset.brands).sort((a,b) => b.length-a.length);
 const form = root.querySelector('form'), brand = form.elements.brand, model = form.elements.model, year = form.elements.year;
 const submit = form.querySelector('[type=submit]'), status = root.querySelector('[data-status]'), results = root.querySelector('[data-results]');
 const fill = (select, values, placeholder) => {
  select.replaceChildren(new Option(placeholder, ''), ...values.map(v => new Option(v.label || v,v.value || v)));
 };
 const clearResults = () => { results.replaceChildren(); status.textContent = ''; };
 let catalog = [];
 try {
  let page = 1;
  while (true) {
   const url = new URL(root.dataset.catalog,location.origin);
   url.searchParams.set('limit','250'); url.searchParams.set('page',String(page));
   const response = await fetch(url,{headers:{Accept:'application/json'}});
   if (!response.ok) throw new Error('catalog');
   const data = await response.json();
   if (!Array.isArray(data.products)) throw new Error('catalog');
   catalog.push(...data.products.map(p => parse(p,brands)).filter(Boolean));
   if(data.products.length < 250) break;
   page++;
   if(page > 100) throw new Error('catalog too large');
  }
  fill(brand,[...new Set(catalog.map(p=>p.brand))].sort((a,b)=>a.localeCompare(b,'es')),msg.brand);
  brand.disabled = false; status.textContent = msg.ready;
 } catch {
  status.textContent = msg.error;
  fill(brand,[],msg.brand);
  return;
 }
 brand.addEventListener('change',() => {
  clearResults();
  const models = [...new Set(catalog.filter(p=>p.brand===brand.value).map(p=>p.model))].sort((a,b)=>a.localeCompare(b,'es',{numeric:true}));
  fill(model,models,msg.model); model.disabled = !brand.value;
  fill(year,[],msg.year); year.disabled=true; submit.disabled=!brand.value;
 });
 model.addEventListener('change',() => {
  clearResults();
  const subset = catalog.filter(p=>p.brand===brand.value && p.model===model.value);
  const years = [...new Set(subset.flatMap(p=>p.years))].sort((a,b)=>Number(b)-Number(a));
  const values = years.map(y=>({label:y,value:y}));
  if(subset.some(p=>!p.years.length)) values.push({label:msg.unknown,value:'unknown'});
  fill(year,values,msg.all); year.disabled=!model.value; submit.disabled=!brand.value;
 });
 year.addEventListener('change',clearResults);
 form.addEventListener('reset',() => {
  clearResults(); fill(model,[],msg.model); fill(year,[],msg.year);
  model.disabled=true; year.disabled=true; submit.disabled=true;
 });
 form.addEventListener('submit',event => {
  event.preventDefault(); clearResults();
  const matched = catalog.filter(p=>p.brand===brand.value && (!model.value || p.model===model.value) && (!year.value || (year.value==='unknown' ? !p.years.length : p.years.includes(year.value))));
  status.textContent = matched.length ? matched.length+' '+msg.count : msg.empty;
  for(const product of matched) {
   const li=document.createElement('li'), link=document.createElement('a');
   const url=new URL(root.dataset.catalog,location.origin);
   url.pathname=url.pathname.replace(/products.json$/,'products/'+encodeURIComponent(product.handle));
   const preview=new URL(location.href).searchParams.get('preview_theme_id');
   if(preview) url.searchParams.set('preview_theme_id',preview);
   link.href=url.pathname+url.search;
   link.textContent=product.title+(!product.years.length ? ' — '+msg.unknown : '');
   li.append(link);results.append(li);
  }
 });
};
document.querySelectorAll('[data-lebel-fitment]').forEach(initialize);
document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('[data-lebel-fitment]').forEach(initialize));
})();